import { render, staticRenderFns } from "./StationTax.vue?vue&type=template&id=55ac5528&scoped=true&"
import script from "./StationTax.vue?vue&type=script&lang=js&"
export * from "./StationTax.vue?vue&type=script&lang=js&"
import style0 from "./StationTax.vue?vue&type=style&index=0&lang=css&"
import style1 from "./StationTax.vue?vue&type=style&index=1&id=55ac5528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac5528",
  null
  
)

export default component.exports